import getChatToken from "app/api/getChatToken";
import postUserOptions from "app/api/requests/Chat/postUserOptions";

export const CHANGE_TELEGRAM = 'CHANGE_TELEGRAM';

export const changeTelegram = (name: string) => (dispatch: any): any => {
	const token = getChatToken();
	dispatch({ type: CHANGE_TELEGRAM, payload: name });
	return postUserOptions(token, {
		telegramName: name
	})
}
